import { schema } from "normalizr";

export const offerSchema = new schema.Entity("offer", {});
export const arrayOfOfferSchemas = new schema.Array(offerSchema);
